import { Component, OnInit } from "@angular/core"
import { HelpersService } from "src/app/services/helpers.service"

@Component({
	selector: "app-notification-area",
	templateUrl: "./notification-area.component.html",
	styleUrls: ["./notification-area.component.scss"]
})
export class NotificationAreaComponent implements OnInit {
	notifications: any
	notificationsList: any[] = []

	constructor(private helpersService: HelpersService) {}

	ngOnInit(): void {
		this.getItems()
	}

	getItems() {
		this.helpersService.getNotifications().subscribe(res => {
			if (res) {
				this.notifications = res
				this.notificationsList = res.notifications
			}
		})
	}
}
